export default __webpack_public_path__ + "step-forward.png";